export const FLAG = {
  TEMPLATE_INSPECT: 'toggleTemplateInspectEnabled',
  TEMPLATE_MERGE: 'toggleTemplateMergeEnabled',
};
